<template>
  <div>
    <img
      id="spinner-img"
      src="../../assets/img/owal-logo-transparent.png"
      alt="Spinning Owal Logo"
    >
    <div id="caption">
      {{ message }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'Spinner',
  props: ['message'],
}
</script>

<style scoped>
#spinner-img {
  animation: spinner-spin infinite 1.0s ease-in-out;
  height: 128px;
  width: 128px;
  margin: 5px auto;
}

#caption
{
  font-weight: bold;
}

@keyframes spinner-spin {
  0% {transform: rotate(180deg); }
  50% {transform: rotate(-180deg);}
  100% {transform: rotate(180deg); }
}
</style>
